import { MutationFunction, useMutation, useQueryClient } from 'react-query';
import { NotificationPreferences, updateNotificationPreferences } from '../../services/apiSLTP/notifications';

type Updates = Partial<Omit<NotificationPreferences, '_id' | 'userId'>>;

const mutationFn: MutationFunction<{ data: NotificationPreferences }, Updates> = (updates) =>
    updateNotificationPreferences(updates);

export const useNotificationPreferencesMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(mutationFn, {
        onSuccess: ({ data }) => {
            queryClient.setQueryData(['notificationPreferences'], data);
        },
    });
};
